<template>
  <div class="footer">
    <p>驊曖體育文化有限公司 2019 © WHAYOGA</p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  background-color: #efefef;
  padding: 13px 0 10px;
  z-index: 200;
  position: relative;
  p {
    text-align: center;
    font-size: 12px;
  }
}
</style>
